<div (pointerdown)="mouseDown()" (pointerup)="mouseUp()" [style.height]="mapHeight" style="background-color: white;">
    <lib-trv-ng-map [layerInput]="nvdbLayerData" [defaultMap]="true"></lib-trv-ng-map>
</div>

<!--
class="map-container"
-->
